// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c2cb31c2","732":"d9825fd9"}[chunkId] + ".chunk.js";
};